/**
 * Get returnUrl from sessionStorage if it exists
 * This is set by the axios interceptor when session expires
 */
export function getReturnUrl(): string | undefined {
  const returnUrl = sessionStorage.getItem('returnUrl');
  if (returnUrl) {
    // Clear it after reading to prevent stale redirects
    sessionStorage.removeItem('returnUrl');
    return returnUrl;
  }
  return undefined;
}
